export interface ParentAthleteNavItem {
  id: string;
  name: string;
}

const STORAGE_KEY = 'parent:recentAthletes';

export const recordParentAthleteVisit = (athlete: ParentAthleteNavItem) => {
  if (!athlete.id || !athlete.name) return;

  try {
    const existing = getRecentParentAthletes(10);
    const next = [athlete, ...existing.filter((item) => item.id !== athlete.id)].slice(0, 10);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    // ignore storage errors
  }
};

export const getRecentParentAthletes = (limit = 3): ParentAthleteNavItem[] => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as ParentAthleteNavItem[];
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((item) => item?.id && item?.name).slice(0, limit);
  } catch {
    return [];
  }
};
